import { useCheckoutContext } from "lib/contexts/CheckoutProvider";
import { CheckoutErrorResponseCode, ItemType } from "lib/types/checkout";
import { useMemo } from "react";

export const useOrderSummary = () => {
  const {
    state: { checkoutItems, errorResponses },
  } = useCheckoutContext();

  const unservicableError = useMemo(
    () =>
      errorResponses?.find((error) =>
        [CheckoutErrorResponseCode.UARC_008, CheckoutErrorResponseCode.UARC_009].includes(error.code),
      ),
    [errorResponses],
  );

  const metadata = unservicableError?.metadata;

  const { servicableItems, unservicableItems } = useMemo(() => {
    if (!metadata) return { servicableItems: checkoutItems, unservicableItems: [] };

    const value = checkoutItems.reduce(
      (acc, item) => {
        if (metadata?.items?.some((innerItem) => innerItem.item_id === item.variant_id)) {
          acc.unservicableItems.push(item);
        } else {
          acc.servicableItems.push(item);
        }
        return acc;
      },
      { servicableItems: [] as ItemType[], unservicableItems: [] as ItemType[] },
    );
    return value;
  }, [checkoutItems, metadata]);

  return {
    servicableItems,
    unservicableItems,
  };
};
